export default {"src":"/_next/static/media/map-pin-sitter.fc3ac5b6.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};